module.exports = __webpack_public_path__ + "img/Parallax_Logo.32b1c356.jpeg";